import React from 'react';
import { Layers } from 'lucide-react';
import type { PluginDefinition } from '@/plugins/types';
import { APP_VERSION } from '@/app/version';

const ChunkVisualizerPage = React.lazy(() =>
  import('./ChunkVisualizerPage').then((m) => ({ default: m.ChunkVisualizerPage }))
);

const fallback = (
  <div className="flex h-full items-center justify-center text-muted-foreground text-sm">
    Lädt…
  </div>
);

export const chunkVisualizerPlugin: PluginDefinition = {
  // Slug bleibt aus Routen-Kompatibilitätsgründen `chunk-visualizer` — DevPlan 0114
  // benennt nur die sichtbaren Labels auf "Sopho Ingest Review" um.
  id: 'chunk-visualizer',
  name: 'Sopho Ingest Review',
  version: APP_VERSION,
  description: 'Review aller Ingest-Ergebnisse pro Dokument: Chunks, Entitäten, Bilder, Tabellen und Pipeline-KPIs (nur Admins).',
  internal: true,
  locked: false,
  enabledByDefault: true,
  group: 'admin',
  // DevPlan 0139/T3: Ingest-Review eines konkreten Workspace → WS-Admin statt Org-Admin.
  accessControl: { minWorkspaceRole: 'Admin' },
  initializationOrder: 95,
  initialize: () => undefined,
  navigation: [
    {
      id: 'chunk-visualizer',
      label: 'Sopho Ingest Review',
      path: '/app/admin/chunk-visualizer',
      icon: Layers,
      order: 95,
      placement: 'footer' as const,
      adminOnly: true,
    },
  ],
  routes: [
    {
      id: 'chunk-visualizer',
      path: 'admin/chunk-visualizer',
      element: (
        <React.Suspense fallback={fallback}>
          <ChunkVisualizerPage />
        </React.Suspense>
      ),
    },
  ],
};
